import React, { useState, useEffect } from 'react';

import { useOutletContext } from 'react-router-dom';
// import { Form } from 'react-bootstrap';
import moment from 'moment';
// import { Steps } from "rsuite";

import MobileFooter from '../Components/MobileFooter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faSeedling } from '@fortawesome/free-solid-svg-icons';

import "../scss/record.scss";

export default function RecordType() {
  const [plantingData, handleIsStartRecord] = useOutletContext();
  const [startDate, setStartDate] = useState(new Date().setHours(0,0,0,0));

  //After checking last step in list, display last step data.
  const stepIndexDefault = function stepIndexDefault(newPlantingData) {
    newPlantingData.stepList.forEach((e, i) => {
      if (Object.keys(e).length === 0) {
        return i;
      }
      return null;
    })
  }

  //making d-day 
  const gap = function gap(plantingData, startDate) {
    const dday = new Date(startDate).getTime() - new Date(plantingData.ts).getTime();
    return Math.ceil(dday / (1000 * 60 * 60 * 24));
  }

  const [saveRecordPlantingData, setSaveRecordPlantingData] = useState();
  const [stepIndex, setStepIndex] = useState(stepIndexDefault(plantingData) || 0);

  return (
    <div className='div-flex-column'>
      <div className='div-flex-column box-shadow'>
        <div style={{ width: 370, marginTop: 10, height: 150 }}>
          <div className='div-flex-row'>
            <div className='div-flex-row' style={{ margin: 20, marginTop: 13 }}>
              { plantingData.cropType }/S1/04
            </div>
          </div>
          <div className='div-flex-row' style={{ marginLeft: 40, marginRight: 40, justifyContent: 'space-between' }}>
            <FontAwesomeIcon icon={ faChevronLeft }/>
            { moment(plantingData.ts).format("YYYY-MM-DD") }
            <FontAwesomeIcon icon={ faChevronRight }/>
          </div>
          <div className='div-flex-row' style={{ marginLeft: 40, marginRight: 40, justifyContent: 'space-between' }}>
            <FontAwesomeIcon icon={ faSeedling } style={{ margin: 5, fontSize: 30 }}/>
            <div style={{ marginTop:5, marginRight:10 }}>+ { gap(plantingData, startDate) }</div>
            { moment(new Date()).format("YYYY-MM-DD") }
          </div>
        </div>
      </div>
      
      <div style={{ height: 100 }}>
      </div>
      <MobileFooter saveRecordPlantingData={saveRecordPlantingData} handleIsStartRecord={handleIsStartRecord}/>
    </div>
  );
}
